/**
 * Enum Tổng hợp dự toán đặc thù Vũ Thư
 * pdtai 27.05.2024
 */
export default {
  ReceiptBudget: 152,
  ReceiptActivity342: 331,
  ReceiptActivity343: 334,
  ReceiptActivity344: 337,
  PaymentBudget: 150,
  PaymentActivity342: 322,
  PaymentActivity343: 325,
  PaymentActivity344: 328,
  PaymentActivityVuThu: 340,
};
